<main >
    <canvas #confettiCanvas class="dashboard-confetti-canvas"></canvas>

    <div class="dashboard-container">
        <div class="header-text" *ngIf="!isEditPage">

            <div class="profile-container">
                <h2>Welcome, {{ user.name }}!</h2>
                <h3 style="opacity: 0.5;">Overview of your upcoming events and student management</h3>
            </div>

            <div class="event-container">
                <h1>Upcoming Events</h1>
                <div class="event-container-item-grid" *ngIf="upcomingEvent.length > 0">
                    <div class="event-container-item" *ngFor="let event of upcomingEvent | slice:0:3"
                        (click)="onViewAdmin(event)">
                        <div class="event-image">
                            <img [src]="event.imagePaths[0] || event.eventTypeImage || '../../../../assets/images/placeholder-image.svg'" alt="" />
                        </div>

                        <div class="item-details">
                            <div class="item-details-label">
                                <div>{{ event.eventStatus }}</div>
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0.21967 8.70502C-0.0732233 8.99791 -0.0732233 9.47279 0.21967 9.76568C0.512563 10.0586 0.987437 10.0586 1.28033 9.76568L0.75 9.23535L0.21967 8.70502ZM9.98528 0.75007C9.98528 0.335857 9.64949 7.03463e-05 9.23528 7.03463e-05H2.48528C2.07107 7.03463e-05 1.73528 0.335857 1.73528 0.75007C1.73528 1.16428 2.07107 1.50007 2.48528 1.50007H8.48528V7.50007C8.48528 7.91428 8.82107 8.25007 9.23528 8.25007C9.64949 8.25007 9.98528 7.91428 9.98528 7.50007V0.75007ZM0.75 9.23535L1.28033 9.76568L9.76561 1.2804L9.23528 0.75007L8.70495 0.21974L0.21967 8.70502L0.75 9.23535Z"
                                        fill="white" />
                                </svg>
                            </div>

                            <!-- <h5>{{ event.eventTypeName }}</h5> -->
                            <h2 class="mt-2">{{ event.eventName }}</h2>

                            <div class="address-item">
                                <div>
                                    <img class="icon-card" src="../../../../assets/images/teacher/calendar.svg" />
                                    <!-- <p>{{ event.eventStartDate | date: 'MMMM d, y' }} - {{ event.eventEndDate | date: 'MMMM d, y' }}</p> -->
                                    <p>
                                        <ng-container *ngIf="event.eventStartDate; else noDate">
                                            {{ event.eventStartDate | date: 'MMMM d, y' }}
                                            <ng-container *ngIf="event.eventEndDate"> - {{ event.eventEndDate | date:
                                                'MMMM d, y' }}</ng-container>
                                        </ng-container>
                                        <ng-template #noDate>-</ng-template>
                                    </p>

                                </div>
                                <div *ngIf="event.eventTime">
                                    <img class="icon-card" src="../../../../assets/images/teacher/clock.svg" />
                                    <p>{{ event.eventTime }}</p>
                                </div>
                                <div>
                                    <img class="icon-card" src="../../../../assets/images/teacher/location.svg" />
                                    <p>{{ event.location }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="upcomingEvent.length === 0" class="no-options">
                    <p>No upcoming events found.</p>
                </div>
            </div>


        </div>

        <div class="work-experience d-flex gap-3">


            <app-button label="Create work experience" [minWidth]="'16rem'"
                (clicked)="openWorkExperienceDialog()"></app-button>
            <!-- <app-export-dropdown label="Export"></app-export-dropdown> -->
        </div>

        <div class="table-card">
            <div class="event-segment">
                <button [disabled]="tableSegment === 'admin'" [ngClass]="{ 'active': tableSegment === 'admin' }"
                    (click)="toggleTabs('admin')">
                    CSQ events
                </button>

                <button [disabled]="tableSegment === 'teacher'" [ngClass]="{ 'active': tableSegment === 'teacher' }"
                    (click)="toggleTabs('teacher')">
                    Teacher-created work experience
                </button>

                <button [disabled]="tableSegment === 'student'" [ngClass]="{ 'active': tableSegment === 'student' }"
                    (click)="toggleTabs('student')">
                    Student-submitted work experience
                </button>
            </div>
            <div>
                <app-table
                    [columns]="tableSegment === 'admin' ? columns : tableSegment === 'teacher' ? secondaryColumn : studentColumn"
                    [data]="data" [actionTemplate]="actionButtonsTemplate" [loading]="loading"
                    (rowClick)="onView($event)">
                </app-table>
            </div>
        </div>

    </div>


    <ng-template #actionButtons let-row>
        <div style="display: flex; gap: 0.8rem; justify-content: center;">
            <img class="action-button" (click)="onView(row)" src="assets/images/Buttons/view-button.svg" alt="View" />
            <img class="action-button" *ngIf="tableSegment === 'teacher'" (click)="onEdit(row)"
                src="assets/images/Buttons/edit-button.svg" alt="Edit" />
            <img class="action-button" *ngIf="tableSegment === 'teacher'" (click)="onDelete(row)"
                src="assets/images/Buttons/delete-button.svg" alt="Delete" />
        </div>
    </ng-template>

</main>